import {
  GenericFlyoutListMenuProps,
  GenericFlyoutListMenuWidget,
  GenericMenuItemInfo
} from '@tableau/widgets';
import * as React from 'react';

export interface ExplorerListMenuPanelStateProps {
  menuItems: GenericMenuItemInfo[];
}

export interface ExplorerListMenuPanelDispatchProps {
  onComponentDidUpdate: () => void;
}

export interface ExplorerListMenuPanelOwnProps extends Pick<GenericFlyoutListMenuProps, 'id' | 'role'> {
  anchorEl: HTMLElement;
  testId: string;
  onCloseRequest: () => void;
  onSelect: (value: string) => void;
  minWidth?: number;
}

export type ExplorerListMenuPanelProps = ExplorerListMenuPanelStateProps
  & ExplorerListMenuPanelDispatchProps & ExplorerListMenuPanelOwnProps;

export class ExplorerListMenuPanel extends React.PureComponent<ExplorerListMenuPanelProps> {

  public componentDidMount(): void {
    // We want to update on mount as well
    this.props.onComponentDidUpdate();
  }

  public componentDidUpdate(): void {
    this.props.onComponentDidUpdate();
  }

  private getButtonClientRect = (): ClientRect => {
    const rect = this.props.anchorEl.getBoundingClientRect();
    return {
      bottom: rect.bottom - 1, // shift up 1 px to cover bottom border for line style dropdown buttons
      top: rect.top,
      width: rect.width,
      height: rect.height,
      right: rect.right,
      left: rect.left
    };
  }

  public render(): JSX.Element {
    return (
      <GenericFlyoutListMenuWidget
          id={this.props.id}
          role={this.props.role}
          menuStyle={{ minWidth: this.props.minWidth, fontWeight: 'normal', top: '-1px' }}
          menuItemInfos={this.props.menuItems}
          onSelect={this.props.onSelect}
          getAnchorClientRect={this.getButtonClientRect}
          testId={this.props.testId}
          toggleEl={this.props.anchorEl}
          handleScrollOnScrollingRoot={this.props.onCloseRequest}
          requestCloseAll={this.props.onCloseRequest}
          allowAutoPosition={true}
          shouldReturnFocusToToggleEl={false}
        />
    );
  }
}
